// plugins/ToursPlugin.js

export default {
    namespaced: true,
    state: {
      tourObject: {
        name: '',
        description: '',
        custom_id: '',
        activity_level: 1,
        is_public: 1,
        is_group_pricing: false,
        group_maxBase_included: null,
        group_base_price: null,
        group_max_capacity: null,
        group_extraPax_price: null,
        regular_price: {adults:null,children:null,infants:null},
        special_price: {adults:null,children:null,infants:null},
        duration: {hours:null,minutes:null},
        tags: [],
        availability: {
          monday: [],
          tuesday: [],
          wednesday: [],
          thursday: [],
          friday: [],
          saturday: [],
          sunday: [],
        },
        default_image: null,
        gallery: [],
        includes: [],
        excludes: [],
        before_booking: [],
        recommendations: [],
        faqs: [],
        omit_children: false,
      },
    },
    mutations: {

      CLEAR_TOUR(state) {
        state.tourObject = {
          name: '',
          description: '',
          custom_id: '',
          activity_level: 1,
          is_public: 1,
          is_group_pricing: false,
          group_maxBase_included: null,
          group_base_price: null,
          group_max_capacity: null,
          group_extraPax_price: null,
          regular_price: {adults:null,children:null,infants:null},
          special_price: {adults:null,children:null,infants:null},
          duration: {hours:null,minutes:null},
          tags: [],
          availability: {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
            saturday: [],
            sunday: [],
          },
          default_image: null,
          gallery: [],
          includes: [],
          excludes: [],
          before_booking: [],
          recommendations: [],
          faqs: [],
          omit_children: false,
        };
      },
      PREFILL_TOUR(state, payload) {
        state.tourObject = payload;
      },
    },
    getters: {
      GET_TOUR(state) {
        return state.tourObject;
      },
    },
    actions: {
      prefillTour({ commit }) {
        const demoData = {
          name: 'test activity',
          description: '<p>test <strong>activity</strong></p>',
          custom_id: 'TEST-001',
          activity_level: 1,
          is_public: 1,
          regular_price: { adults: 80, children: 40, infants: 0 },
          special_price: { adults: null, children: null, infants: null },
          duration: { hours: 2, minutes: 10 },
          tags: [1, 2, 3],
          availability: {
            monday: [{ start: '08:00' }, { start: '09:00' }],
            tuesday: [],
            wednesday: [{ start: '08:00' }, { start: '09:00' }],
            thursday: [],
            friday: [{ start: '08:00' }, { start: '09:00' }],
            saturday: [{ start: '11:00' }],
            sunday: [],
          },
          default_image: null,
          gallery: [],
          includes: [
            'A scenic journey across the bay aboard our modern French-made sailboats or catamaran.',
            'Delicious appetizers and lunch served onboard',
            'Invigorating open bar with a selection of beverages',
            'Provided snorkeling gear and paddleboards for aquatic exploration',
            'Leisure time to enjoy the stunning bays of Los Cabos',
          ],
          excludes: ['Photos', 'Souvenirs', 'Transportation', 'Towels'],
          before_booking: [
            'The entrance dock fee is $2 USD per person. Please note that this fee is not included and should be paid at check-in.',
            'Minimum age: 8 years old',
            'Maximum weight per person: 265 lbs/120 kg',
            'We kindly request guests to remove their footwear when boarding the sailboat.',
          ],
          recommendations: [
            'Swimwear',
            'Comfortable clothes',
            'Towel',
            'Light sweater (winter)',
            'Biodegradable sunscreen',
            'Hat',
            'Money for photos, gratuities and souvenirs',
          ],
          faqs: [
            {
              question: "What's the difference between a sailboat and a catamaran?",
              answer:
                '<p>Sailboats, such as our <strong>sleek 50 ft French-made vessels</strong>, are single-hulled and often favored for their intimate settings, ideal for small groups. They cut through the water with elegance, providing a classic and cozy sailing experience.<br><br>On the other hand, catamarans, like our spacious vessels accommodating up to 24 passengers, feature dual hulls connected by a central platform.</p>',
            },
            {
              question: 'Where does this sailing tour depart?',
              answer:
                '<p>The 4-Hour Luxury Cabo Sailing tour departs from Cabo San Lucas, offering a convenient starting point for your oceanic escapade. The departure location ensures easy access to the stunning Sea of Cortez, allowing you to swiftly embark on your luxury sailing journey to explore the natural wonders of the Cabo San Lucas region.</p>',
            },
          ],
        };
        commit('PREFILL_TOUR', demoData);
      },
      updateTourItem({ commit }, tourData) {
        const formattedData = {
            id: tourData.id || '',
            name: tourData.name || '',
            description: tourData.description || '',
            custom_id: tourData.custom_id || '',
            activity_level: tourData.activity_level || 1,
            is_public: tourData.is_public || 1,
            is_group_pricing: !!tourData.is_group_pricing, // 🔁 NUEVO
            group_base_price: tourData.group_base_price || null, // 🔁 NUEVO
            group_maxBase_included: tourData.group_maxBase_included || null, // 🔁 NUEVO
            group_max_capacity: tourData.group_max_capacity || null, // 🔁 NUEVO
            group_extraPax_price: tourData.group_extraPax_price || null, // 🔁 NUEVO
            regular_price: tourData.regular_price || { adults: null, children: null, infants: null },
            special_price: tourData.special_price || { adults: null, children: null, infants: null },
            duration: tourData.duration || { hours: null, minutes: null },
            tags: tourData.tags || [],
            availability: tourData.availability || {
                monday: [], tuesday: [], wednesday: [], thursday: [],
                friday: [], saturday: [], sunday: []
            },
            default_image: tourData.default_image || null,
            gallery: tourData.gallery || [],
            includes: tourData.includes || [],
            excludes: tourData.excludes || [],
            before_booking: tourData.before_booking || [],
            recommendations: tourData.recommendations || [],
            faqs: tourData.faqs || [],
            omit_children: tourData.omit_children || false,
        };
    
        commit('PREFILL_TOUR', formattedData);
      },    
      async get_Tours(_, {Authtoken, userCompany}) {
        try {

          // console.log('sessionUser', sessionUser);
          const API_URL = `${this.state.base_URL}tours_and_activities`;
          // console.log('userType: ', userType)

          // Create headers object with common headers
          const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Authtoken}`,
            'User-Company': userCompany
          };
      
          const res = await fetch(API_URL, {
            method: 'GET',
            headers: headers
          });
      
          const response = await res.json();
      
          // console.log('Response from server:', response);
      
          if ('errors' in response) {
            return response.errors;
          }
    
          return response;
        } catch (error) {
          // console.error('Error during query:', error);
          throw new Error(error);
        }
      },
      async get_Tags(_, {Authtoken, userCompany}) {
        try {

          // console.log('sessionUser', sessionUser);
          const API_URL = `${this.state.base_URL}tours_and_activities_tags`;
          // console.log('userType: ', userType)

          // Create headers object with common headers
          const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Authtoken}`,
            'User-Company': userCompany
          };
      
          const res = await fetch(API_URL, {
            method: 'GET',
            headers: headers
          });
      
          const response = await res.json();
      
          // console.log('Response from server:', response);
      
          if ('errors' in response) {
            return response.errors;
          }
    
          return response;
        } catch (error) {
          // console.error('Error during query:', error);
          throw new Error(error);
        }
      },
      async get_FormatedTags(_, {Authtoken, userCompany}) {
        try {

          // console.log('sessionUser', sessionUser);
          const API_URL = `${this.state.base_URL}formatted_tours_tags`;
          // console.log('userType: ', userType)

          // Create headers object with common headers
          const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Authtoken}`,
            'User-Company': userCompany
          };
      
          const res = await fetch(API_URL, {
            method: 'GET',
            headers: headers
          });
      
          const response = await res.json();
      
          // console.log('Response from server:', response);
      
          if ('errors' in response) {
            return response.errors;
          }
    
          return response;
        } catch (error) {
          // console.error('Error during query:', error);
          throw new Error(error);
        }
      },
      async getTourInfo(_,{Authtoken, TourID}) {
        try {
          const API_URL = `${this.state.base_URL}tours_and_activities/${TourID}`;
      
          const res = await fetch(API_URL, {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${Authtoken}`
            },
          });
      
          const response = await res.json();
      
          // console.log('Response from server:', response);
      
          if ('errors' in response) {
            return response.errors;
          }
      
          return response;
        } catch (error) {
          console.error('Error during query:', error);
          throw new Error(error);
        }
      },
      async create_Tours(_, dataToUpdate) {
        try {
          const API_URL = `${this.state.base_URL}tours_and_activities`;
      
          console.log('Data to process:', dataToUpdate);
      
          // Crear FormData para datos de tipo multipart/form-data
          const formData = new FormData();
          for (const key in dataToUpdate.tourObject) {
            if (key === 'TnA_gallery') {
              // Agregar cada imagen de la galería individualmente
              dataToUpdate.tourObject.TnA_gallery.forEach((file, index) => {
                formData.append(`tourObject[TnA_gallery][${index}]`, file);
              });
            } else if (key === 'TnA_main_image') {
              // Agregar la imagen principal
              formData.append(`tourObject[${key}]`, dataToUpdate.tourObject[key]);
            } else if (key === 'TnA_tags') {
                // Serializar los tags como un objeto JSON
                formData.append('tourObject[TnA_tags]', JSON.stringify(dataToUpdate.tourObject.TnA_tags));
            } else if (key === 'TnA_regular_price' || key === 'TnA_special_price') {
              // Descomponer el objeto de precios en campos anidados
              const priceObj = dataToUpdate.tourObject[key];
              for (const subKey in priceObj) {
                  if (priceObj[subKey] !== null) {
                      formData.append(`tourObject[${key}][${subKey}]`, priceObj[subKey]);
                  }
              }
            } else {
              // Agregar otros datos
              formData.append(`tourObject[${key}]`, dataToUpdate.tourObject[key]);
            }
          }
      
          // Agregar el token y el companyID al FormData
          formData.append('token', dataToUpdate.token);
          formData.append('companyID', dataToUpdate.companyID);
      
          // Log para mostrar qué se incluye en FormData
          // console.log('FormData content:');
          // for (const pair of formData.entries()) {
          //   console.log(`${pair[0]}:`, pair[1]);
          // }
      
          const headers = {
            Accept: 'application/json',
            Authorization: `Bearer ${dataToUpdate.token}`,
            'User-Company': dataToUpdate.companyID,
          };
      
          const res = await fetch(API_URL, {
            method: 'POST',
            headers,
            body: formData,
          });
      
          const response = await res.json();
          console.log('Response from server:', response);
      
          if ('errors' in response) {
            return response.errors;
          }
      
          return response;
        } catch (error) {
          console.error('Error during query:', error);
          throw new Error(error);
        }
      },         
      async update_Tours(_, dataToUpdate) {
        try {
          const API_URL = `${this.state.base_URL}tours_and_activities/${dataToUpdate.TourID}`;
          console.log('Data to update:', dataToUpdate);

          // Crear FormData
          const formData = new FormData();

          // Procesar los campos del objeto
          for (const key in dataToUpdate.tourObject) {
            if (key === 'TnA_tags') {
                // Agregar cada tag con índices específicos
                dataToUpdate.tourObject.TnA_tags.forEach((tag, index) => {
                    formData.append(`tourObject[TnA_tags][${index}]`, tag);
                });
            } else {
                formData.append(`tourObject[${key}]`, dataToUpdate.tourObject[key]);
            }
          }
          // Agregar `_method: PUT` al FormData
          dataToUpdate.formData.append('_method', 'PUT');
      
          const headers = {
            Accept: 'application/json',
            Authorization: `Bearer ${dataToUpdate.token}`,
            'User-Company': dataToUpdate.companyID,
          };
      
          const res = await fetch(API_URL, {
            method: 'POST', // Laravel espera POST con `_method: PUT`
            headers,
            body: dataToUpdate.formData,
          });
      
          const response = await res.json();
          console.log('Response from server:', response);
      
          if ('errors' in response) {
            return response.errors;
          }
      
          return response;
        } catch (error) {
          console.error('Error during query:', error);
          throw new Error(error);
        }
      },   
      async updateStatus(_, { Authtoken, TourID, status }) {
        try {
          
          const API_URL = `${this.state.base_URL}update/tna-status/${TourID}`;
      
          const res = await fetch(API_URL, {
            method: 'PUT',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${Authtoken}`,
              'status': status
            }
          });
      
          const response = await res.json();
      
          // console.log('Response from server:', response);
      
          if ('errors' in response) {
            return response.errors;
          }
      
          return response;
        } catch (error) {
          console.error('Error during query:', error);
          throw new Error(error);
        }
      },
      async activate_Tours(_, { Authtoken, fleetID }) {
        try {
          
          const API_URL = `${this.state.base_URL}tours_and_activities/${fleetID}`;
      
          const res = await fetch(API_URL, {
            method: 'PUT',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${Authtoken}`
            },
            body: JSON.stringify({
              vehiclePerCompany_status: 1
            })
          });
      
          const response = await res.json();
      
          // console.log('Response from server:', response);
      
          if ('errors' in response) {
            return response.errors;
          }
      
          return response;
        } catch (error) {
          console.error('Error during query:', error);
          throw new Error(error);
        }
      },
      async delete_Tours(_, { Authtoken, fleetID }) {
        try {
          
          const API_URL = `${this.state.base_URL}tours_and_activities/${fleetID}`;
      
          const res = await fetch(API_URL, {
            method: 'PUT',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${Authtoken}`
            },
            body: JSON.stringify({
              vehiclePerCompany_status: 3
            })
          });
      
          const response = await res.json();
      
          // console.log('Response from server:', response);
      
          if ('errors' in response) {
            return response.errors;
          }
      
          return response;
        } catch (error) {
          console.error('Error during query:', error);
          throw new Error(error);
        }
      },
      async delete_Tours_permanently(_, { Authtoken, TourID }) {
        try {
          
          const API_URL = `${this.state.base_URL}tours_and_activities/${TourID}`;
      
          const res = await fetch(API_URL, {
            method: 'DELETE',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${Authtoken}`
            },
          });
      
          const response = await res.json();
      
          // console.log('Response from server:', response);
      
          if ('errors' in response) {
            return response.errors;
          }
      
          return response;
        } catch (error) {
          console.error('Error during query:', error);
          throw new Error(error);
        }
      },
      // ... otras acciones relacionadas con los empresas
    }
  }